var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2[Currency2["UNKNOWN_CURRENCY"] = 0] = "UNKNOWN_CURRENCY";
  Currency2[Currency2["AED"] = 784] = "AED";
  Currency2[Currency2["AFN"] = 971] = "AFN";
  Currency2[Currency2["ALL"] = 8] = "ALL";
  Currency2[Currency2["AMD"] = 51] = "AMD";
  Currency2[Currency2["ANG"] = 532] = "ANG";
  Currency2[Currency2["AOA"] = 973] = "AOA";
  Currency2[Currency2["ARS"] = 32] = "ARS";
  Currency2[Currency2["AUD"] = 36] = "AUD";
  Currency2[Currency2["AWG"] = 533] = "AWG";
  Currency2[Currency2["AZN"] = 944] = "AZN";
  Currency2[Currency2["BAM"] = 977] = "BAM";
  Currency2[Currency2["BBD"] = 52] = "BBD";
  Currency2[Currency2["BDT"] = 50] = "BDT";
  Currency2[Currency2["BGN"] = 975] = "BGN";
  Currency2[Currency2["BHD"] = 48] = "BHD";
  Currency2[Currency2["BIF"] = 108] = "BIF";
  Currency2[Currency2["BMD"] = 60] = "BMD";
  Currency2[Currency2["BND"] = 96] = "BND";
  Currency2[Currency2["BOB"] = 68] = "BOB";
  Currency2[Currency2["BOV"] = 984] = "BOV";
  Currency2[Currency2["BRL"] = 986] = "BRL";
  Currency2[Currency2["BSD"] = 44] = "BSD";
  Currency2[Currency2["BTN"] = 64] = "BTN";
  Currency2[Currency2["BWP"] = 72] = "BWP";
  Currency2[Currency2["BYR"] = 974] = "BYR";
  Currency2[Currency2["BZD"] = 84] = "BZD";
  Currency2[Currency2["CAD"] = 124] = "CAD";
  Currency2[Currency2["CDF"] = 976] = "CDF";
  Currency2[Currency2["CHE"] = 947] = "CHE";
  Currency2[Currency2["CHF"] = 756] = "CHF";
  Currency2[Currency2["CHW"] = 948] = "CHW";
  Currency2[Currency2["CLF"] = 990] = "CLF";
  Currency2[Currency2["CLP"] = 152] = "CLP";
  Currency2[Currency2["CNY"] = 156] = "CNY";
  Currency2[Currency2["COP"] = 170] = "COP";
  Currency2[Currency2["COU"] = 970] = "COU";
  Currency2[Currency2["CRC"] = 188] = "CRC";
  Currency2[Currency2["CUC"] = 931] = "CUC";
  Currency2[Currency2["CUP"] = 192] = "CUP";
  Currency2[Currency2["CVE"] = 132] = "CVE";
  Currency2[Currency2["CZK"] = 203] = "CZK";
  Currency2[Currency2["DJF"] = 262] = "DJF";
  Currency2[Currency2["DKK"] = 208] = "DKK";
  Currency2[Currency2["DOP"] = 214] = "DOP";
  Currency2[Currency2["DZD"] = 12] = "DZD";
  Currency2[Currency2["EGP"] = 818] = "EGP";
  Currency2[Currency2["ERN"] = 232] = "ERN";
  Currency2[Currency2["ETB"] = 230] = "ETB";
  Currency2[Currency2["EUR"] = 978] = "EUR";
  Currency2[Currency2["FJD"] = 242] = "FJD";
  Currency2[Currency2["FKP"] = 238] = "FKP";
  Currency2[Currency2["GBP"] = 826] = "GBP";
  Currency2[Currency2["GEL"] = 981] = "GEL";
  Currency2[Currency2["GHS"] = 936] = "GHS";
  Currency2[Currency2["GIP"] = 292] = "GIP";
  Currency2[Currency2["GMD"] = 270] = "GMD";
  Currency2[Currency2["GNF"] = 324] = "GNF";
  Currency2[Currency2["GTQ"] = 320] = "GTQ";
  Currency2[Currency2["GYD"] = 328] = "GYD";
  Currency2[Currency2["HKD"] = 344] = "HKD";
  Currency2[Currency2["HNL"] = 340] = "HNL";
  Currency2[Currency2["HRK"] = 191] = "HRK";
  Currency2[Currency2["HTG"] = 332] = "HTG";
  Currency2[Currency2["HUF"] = 348] = "HUF";
  Currency2[Currency2["IDR"] = 360] = "IDR";
  Currency2[Currency2["ILS"] = 376] = "ILS";
  Currency2[Currency2["INR"] = 356] = "INR";
  Currency2[Currency2["IQD"] = 368] = "IQD";
  Currency2[Currency2["IRR"] = 364] = "IRR";
  Currency2[Currency2["ISK"] = 352] = "ISK";
  Currency2[Currency2["JMD"] = 388] = "JMD";
  Currency2[Currency2["JOD"] = 400] = "JOD";
  Currency2[Currency2["JPY"] = 392] = "JPY";
  Currency2[Currency2["KES"] = 404] = "KES";
  Currency2[Currency2["KGS"] = 417] = "KGS";
  Currency2[Currency2["KHR"] = 116] = "KHR";
  Currency2[Currency2["KMF"] = 174] = "KMF";
  Currency2[Currency2["KPW"] = 408] = "KPW";
  Currency2[Currency2["KRW"] = 410] = "KRW";
  Currency2[Currency2["KWD"] = 414] = "KWD";
  Currency2[Currency2["KYD"] = 136] = "KYD";
  Currency2[Currency2["KZT"] = 398] = "KZT";
  Currency2[Currency2["LAK"] = 418] = "LAK";
  Currency2[Currency2["LBP"] = 422] = "LBP";
  Currency2[Currency2["LKR"] = 144] = "LKR";
  Currency2[Currency2["LRD"] = 430] = "LRD";
  Currency2[Currency2["LSL"] = 426] = "LSL";
  Currency2[Currency2["LTL"] = 440] = "LTL";
  Currency2[Currency2["LVL"] = 428] = "LVL";
  Currency2[Currency2["LYD"] = 434] = "LYD";
  Currency2[Currency2["MAD"] = 504] = "MAD";
  Currency2[Currency2["MDL"] = 498] = "MDL";
  Currency2[Currency2["MGA"] = 969] = "MGA";
  Currency2[Currency2["MKD"] = 807] = "MKD";
  Currency2[Currency2["MMK"] = 104] = "MMK";
  Currency2[Currency2["MNT"] = 496] = "MNT";
  Currency2[Currency2["MOP"] = 446] = "MOP";
  Currency2[Currency2["MRO"] = 478] = "MRO";
  Currency2[Currency2["MUR"] = 480] = "MUR";
  Currency2[Currency2["MVR"] = 462] = "MVR";
  Currency2[Currency2["MWK"] = 454] = "MWK";
  Currency2[Currency2["MXN"] = 484] = "MXN";
  Currency2[Currency2["MXV"] = 979] = "MXV";
  Currency2[Currency2["MYR"] = 458] = "MYR";
  Currency2[Currency2["MZN"] = 943] = "MZN";
  Currency2[Currency2["NAD"] = 516] = "NAD";
  Currency2[Currency2["NGN"] = 566] = "NGN";
  Currency2[Currency2["NIO"] = 558] = "NIO";
  Currency2[Currency2["NOK"] = 578] = "NOK";
  Currency2[Currency2["NPR"] = 524] = "NPR";
  Currency2[Currency2["NZD"] = 554] = "NZD";
  Currency2[Currency2["OMR"] = 512] = "OMR";
  Currency2[Currency2["PAB"] = 590] = "PAB";
  Currency2[Currency2["PEN"] = 604] = "PEN";
  Currency2[Currency2["PGK"] = 598] = "PGK";
  Currency2[Currency2["PHP"] = 608] = "PHP";
  Currency2[Currency2["PKR"] = 586] = "PKR";
  Currency2[Currency2["PLN"] = 985] = "PLN";
  Currency2[Currency2["PYG"] = 600] = "PYG";
  Currency2[Currency2["QAR"] = 634] = "QAR";
  Currency2[Currency2["RON"] = 946] = "RON";
  Currency2[Currency2["RSD"] = 941] = "RSD";
  Currency2[Currency2["RUB"] = 643] = "RUB";
  Currency2[Currency2["RWF"] = 646] = "RWF";
  Currency2[Currency2["SAR"] = 682] = "SAR";
  Currency2[Currency2["SBD"] = 90] = "SBD";
  Currency2[Currency2["SCR"] = 690] = "SCR";
  Currency2[Currency2["SDG"] = 938] = "SDG";
  Currency2[Currency2["SEK"] = 752] = "SEK";
  Currency2[Currency2["SGD"] = 702] = "SGD";
  Currency2[Currency2["SHP"] = 654] = "SHP";
  Currency2[Currency2["SLL"] = 694] = "SLL";
  Currency2[Currency2["SLE"] = 925] = "SLE";
  Currency2[Currency2["SOS"] = 706] = "SOS";
  Currency2[Currency2["SRD"] = 968] = "SRD";
  Currency2[Currency2["SSP"] = 728] = "SSP";
  Currency2[Currency2["STD"] = 678] = "STD";
  Currency2[Currency2["SVC"] = 222] = "SVC";
  Currency2[Currency2["SYP"] = 760] = "SYP";
  Currency2[Currency2["SZL"] = 748] = "SZL";
  Currency2[Currency2["THB"] = 764] = "THB";
  Currency2[Currency2["TJS"] = 972] = "TJS";
  Currency2[Currency2["TMT"] = 934] = "TMT";
  Currency2[Currency2["TND"] = 788] = "TND";
  Currency2[Currency2["TOP"] = 776] = "TOP";
  Currency2[Currency2["TRY"] = 949] = "TRY";
  Currency2[Currency2["TTD"] = 780] = "TTD";
  Currency2[Currency2["TWD"] = 901] = "TWD";
  Currency2[Currency2["TZS"] = 834] = "TZS";
  Currency2[Currency2["UAH"] = 980] = "UAH";
  Currency2[Currency2["UGX"] = 800] = "UGX";
  Currency2[Currency2["USD"] = 840] = "USD";
  Currency2[Currency2["USN"] = 997] = "USN";
  Currency2[Currency2["USS"] = 998] = "USS";
  Currency2[Currency2["UYI"] = 940] = "UYI";
  Currency2[Currency2["UYU"] = 858] = "UYU";
  Currency2[Currency2["UZS"] = 860] = "UZS";
  Currency2[Currency2["VEF"] = 937] = "VEF";
  Currency2[Currency2["VND"] = 704] = "VND";
  Currency2[Currency2["VUV"] = 548] = "VUV";
  Currency2[Currency2["WST"] = 882] = "WST";
  Currency2[Currency2["XAF"] = 950] = "XAF";
  Currency2[Currency2["XAG"] = 961] = "XAG";
  Currency2[Currency2["XAU"] = 959] = "XAU";
  Currency2[Currency2["XBA"] = 955] = "XBA";
  Currency2[Currency2["XBB"] = 956] = "XBB";
  Currency2[Currency2["XBC"] = 957] = "XBC";
  Currency2[Currency2["XBD"] = 958] = "XBD";
  Currency2[Currency2["XCD"] = 951] = "XCD";
  Currency2[Currency2["XDR"] = 960] = "XDR";
  Currency2[Currency2["XOF"] = 952] = "XOF";
  Currency2[Currency2["XPD"] = 964] = "XPD";
  Currency2[Currency2["XPF"] = 953] = "XPF";
  Currency2[Currency2["XPT"] = 962] = "XPT";
  Currency2[Currency2["XTS"] = 963] = "XTS";
  Currency2[Currency2["XXX"] = 999] = "XXX";
  Currency2[Currency2["YER"] = 886] = "YER";
  Currency2[Currency2["ZAR"] = 710] = "ZAR";
  Currency2[Currency2["ZMK"] = 894] = "ZMK";
  Currency2[Currency2["ZMW"] = 967] = "ZMW";
  Currency2[Currency2["BTC"] = 1001] = "BTC";
  Currency2[Currency2["XUS"] = 1002] = "XUS";
  return Currency2;
})(Currency || {});
export {
  Currency
};
//# sourceMappingURL=connect-v2-currency.js.map
